// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container__1Wv6T","icon":"Info_icon__1jXOL","text":"Info_text__tb0C9","disabled":"Info_disabled__2aKdN"};